import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { setSavedHypotheticalId } from '../../state/saved-hypothetical-id/saved-hypothetical-id.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep } from '../../state/wizard-step/wizard-step.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from '../../state/reducer';
import { getCurrentWizardStepIndex, getSavedHypotheticalId, getWizardStepEventName } from '../../state/selectors';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
import { OpenItemModalAction } from 'NewAngular/features/components/saved-items/open-item-modal/enums/open-item-modal-action.enum';
import { SavedHypotheticalService } from 'HypotheticalsApp/services/saved-hypothetical.service';
import { OpenItemTabsComponent } from 'NewAngular/features/components/saved-items/open-item-modal/components/open-item-tabs/open-item-tabs.component';
import * as i0 from "@angular/core";
import * as i1 from "HypotheticalsApp/services/saved-hypothetical.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i7 from "NewAngular/features/components/saved-items/open-item-modal/components/open-item-tabs/open-item-tabs.component";
const _c0 = ["openItemTabsComponent"];
function ReportHypotheticalSelectorModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function ReportHypotheticalSelectorModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function ReportHypotheticalSelectorModalComponent_div_11_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.back()); });
    i0.ɵɵtext(1, "Back ");
    i0.ɵɵelementEnd();
} }
export class ReportHypotheticalSelectorModalComponent {
    constructor(savedHypotheticalService, store) {
        this.savedHypotheticalService = savedHypotheticalService;
        this.store = store;
        // Outputs
        this.broadcastWizardStepEvent = new EventEmitter();
        // Data & flags
        this.savedHypotheticals = [];
        this.sharedSavedHypotheticals = [];
        this.isOpen = false;
        this.forwardDisabled = true;
        this.currentWizardStepIndex = null;
        this.selectedSavedHypothetical = null;
        // From state:
        this.savedHypotheticalId = null;
        this.savedItemType = SavedItemType.HYPOTHETICAL;
        this.errorMessage = '';
        this.mapStateToComponent = (state) => {
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            if (!this.isOpen &&
                this.currentWizardStepIndex === 0 &&
                getWizardStepEventName(state) === CustomPDFReportModalEventName.SHOW_SELECT_SAVED_HYPOTHETICAL_MODAL) {
                this.openModal();
            }
            this.savedHypotheticalId = getSavedHypotheticalId(state);
            if (this.savedHypotheticalId == null) {
                this.selectedSavedHypothetical = null;
                if (this.openItemTabsComponent) {
                    this.openItemTabsComponent.clearSelection();
                }
            }
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    selectSavedHypothetical(itemAndAction) {
        this.selectedSavedHypothetical = itemAndAction.item;
        this.forwardDisabled = false;
        const savedHypotheticalId = itemAndAction.item ? Number(itemAndAction.item.id) : null;
        this.store.dispatch(setSavedHypotheticalId({ savedHypotheticalId }));
    }
    closeModal() {
        this.isOpen = false;
    }
    openModal() {
        this.isOpen = true;
        // Refresh the savedHypotheticals list in case new items were added
        this.savedHypotheticalService.getItems().subscribe((savedHypotheticals) => {
            this.savedHypotheticals = savedHypotheticals.filter((savedHypothetical) => {
                return savedHypothetical.sharing.is_owner;
            });
            this.sharedSavedHypotheticals = savedHypotheticals.filter((savedHypothetical) => {
                return !savedHypothetical.sharing.is_owner;
            });
            this.errorMessage = '';
            this.restoreSelectionFromStore();
        }, () => {
            this.savedHypotheticals = [];
            this.sharedSavedHypotheticals = [];
            this.errorMessage =
                'There was an error loading your saved scenarios. Please try again or contact support.';
        });
    }
    restoreSelectionFromStore() {
        if (this.selectedSavedHypothetical == null && this.savedHypotheticalId) {
            let matchedItem;
            let matchedTab = 'own';
            matchedItem = this.savedHypotheticals.find((item) => item.id === this.savedHypotheticalId);
            if (!matchedItem) {
                matchedItem = this.sharedSavedHypotheticals.find((item) => item.id === this.savedHypotheticalId);
                matchedTab = 'shared';
            }
            if (matchedItem) {
                this.selectSavedHypothetical({
                    item: matchedItem,
                    actionType: OpenItemModalAction.SELECT,
                });
                this.openItemTabsComponent.activeTab = matchedTab;
                if (matchedTab === 'own') {
                    this.openItemTabsComponent.ownSelectedItemId = matchedItem.id;
                }
                else {
                    this.openItemTabsComponent.sharedSelectedItemId = matchedItem.id;
                }
            }
            else {
                this.selectedSavedHypothetical = null;
                this.forwardDisabled = true;
                this.openItemTabsComponent.clearSelection();
                this.store.dispatch(setSavedHypotheticalId({ savedHypotheticalId: null }));
            }
        }
    }
    back() {
        this.closeModal();
        if (this.currentWizardStepIndex) {
            this.store.dispatch(decrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
        else {
            this.store.dispatch(resetAllCustomPdfReportItems());
        }
    }
    forward() {
        this.closeModal();
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
}
ReportHypotheticalSelectorModalComponent.ɵfac = function ReportHypotheticalSelectorModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReportHypotheticalSelectorModalComponent)(i0.ɵɵdirectiveInject(i1.SavedHypotheticalService), i0.ɵɵdirectiveInject(i2.Store)); };
ReportHypotheticalSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportHypotheticalSelectorModalComponent, selectors: [["ycn-report-hypothetical-selector-modal"]], viewQuery: function ReportHypotheticalSelectorModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.openItemTabsComponent = _t.first);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 13, vars: 13, consts: [["openItemTabsComponent", ""], [3, "closeModalHandler", "open", "extraModalClasses"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "doActionOnItemHandler", "ownItems", "sharedItems", "sharedWithMeEnabled", "selectOnly", "savedItemType", "showRadioButtons"], [1, "modal-footer"], [1, "modal-footer-info"], ["class", "text-red", 3, "textContent", 4, "ngIf"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], ["class", "btn btn-secondary", 3, "click", 4, "ngIf"], ["data-test-id", "submit-scenario-report-securities", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled", "innerText"], [1, "text-red", 3, "textContent"], [1, "btn", "btn-secondary", 3, "click"]], template: function ReportHypotheticalSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function ReportHypotheticalSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function ReportHypotheticalSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "ycn-open-item-tabs", 4, 0);
        i0.ɵɵlistener("doActionOnItemHandler", function ReportHypotheticalSelectorModalComponent_Template_ycn_open_item_tabs_doActionOnItemHandler_3_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectSavedHypothetical($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵtemplate(7, ReportHypotheticalSelectorModalComponent_div_7_Template, 1, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8)(9, "div", 9);
        i0.ɵɵlistener("click", function ReportHypotheticalSelectorModalComponent_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵtext(10, "Cancel ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, ReportHypotheticalSelectorModalComponent_div_11_Template, 2, 0, "div", 10);
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵlistener("click", function ReportHypotheticalSelectorModalComponent_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen)("extraModalClasses", "modal-no-border");
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Saved Scenario");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ownItems", ctx.savedHypotheticals)("sharedItems", ctx.sharedSavedHypotheticals)("sharedWithMeEnabled", true)("selectOnly", true)("savedItemType", ctx.savedItemType)("showRadioButtons", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.currentWizardStepIndex != 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", ctx.forwardDisabled)("innerText", "Next");
    } }, dependencies: [i3.NgIf, i4.DisabledDirective, i5.ModalBaseComponent, i6.SimpleModalHeaderComponent, i7.OpenItemTabsComponent], encapsulation: 2 });
